import type { ReactionType } from "./Reaction";
import { Reaction } from "./Reaction";
import { PopoverWrapper } from "./popover/PopoverWrapper";

export interface ReactionsProps {
  currentCommunityMemberId: number;
  isRenderedOnHeader?: boolean;
  isViewOnlyMasquerading: boolean;
  reactionableId: number;
  reactionableType: string;
  reactions: ReactionType[];
}

export const Reactions = ({
  reactions = [],
  currentCommunityMemberId,
  reactionableId,
  reactionableType,
  isRenderedOnHeader = false,
  isViewOnlyMasquerading,
}: ReactionsProps) => (
  <div className="flex flex-wrap gap-1">
    {reactions.map(reaction => (
      <Reaction
        key={reaction.emoji}
        reaction={reaction}
        currentCommunityMemberId={currentCommunityMemberId}
        reactionableId={reactionableId}
        reactionableType={reactionableType}
        isViewOnlyMasquerading={isViewOnlyMasquerading}
      />
    ))}
    {Boolean(currentCommunityMemberId) && (
      <PopoverWrapper
        reactions={reactions}
        currentCommunityMemberId={currentCommunityMemberId}
        reactionableId={reactionableId}
        reactionableType={reactionableType}
        showBorder
        isRenderedOnHeader={isRenderedOnHeader}
      />
    )}
  </div>
);
